import React, { Component } from "react";
import { authorize } from "../network/api";
import { confirm, enter_your_mobile, error_dots, mobile } from "../resources/string/strings";
import { getDeviceName, getOs, getOsVersion, getDeviceUniqueId, setSessionKeyId } from "../authentication/authorizer";

class AuthenticationMobile extends Component {
  state = {
    pageTitle: "ورود به حساب",
    pageTag: "authMobile",
    mobile: "",
    error: "",
    loading: false,
  };

  componentDidMount() {
    document.title = this.state.pageTitle;
  }

  render() {
    return (
      <div className="fragment">
          <div className="app-card mx-auto text-center bg-white col-12 col-sm-12 col-md-9 col-lg-7 col-xl-6">
          <div className="card-body">
            <h5 className="text-lg mt-2 mb-5">{enter_your_mobile}</h5>
            <form onSubmit={this.handleSubmit}>
              <input
                style={{ width: 280, height: 45, paddingBottom: 3 }}
                className="input-group-text mb-4 mx-auto text-center"
                type="text"
                pattern="[0-9]*"
                name="mobile"
                maxLength="11"
                placeholder={mobile}
                value={this.state.mobile}
                onChange={this.handleFormChange}
                required
              />
              <button
                style={{ width: 280, height: 45, paddingBottom: 6 }}
                className="btn btn-success mb-4 mx-auto text-center"
                type="submit"
                disabled={this.state.loading}
              >
                <div>{confirm}</div>
              </button>

              {this.state.error.length > 0 && (
                <p style={{ width: 280 }} className="alert alert-danger mx-auto">
                  <strong>{error_dots}</strong>{this.state.error}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    );
  }

  handleFormChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
      error: ""
    });
  };

  handleSubmit = (event) => {
    this.callAuthorizeApi();
    event.preventDefault();
  };

  goToCode(expirationTime) {
    this.props.history.push({
      pathname: "/authenticationCode",
      search: `?mo=${this.state.mobile}&exp=${expirationTime}`,
    });
  }

  /****
   ** NETWORK CALLS
   *****/

  callAuthorizeApi() {
    const { mobile } = this.state;
    this.setState({loading : true})
    authorize(mobile, getDeviceUniqueId(), getDeviceName(), getOs(), getOsVersion(), this.handleAuthurizeApiSuccess, this.handleAuthurizeApiFailure);
  }

  handleAuthurizeApiSuccess = (data) => {
    this.setState({ loading: false });
    setSessionKeyId(data.sessionKeyId)
    this.goToCode(data.expirationTime);
  };

  handleAuthurizeApiFailure = (error) => {
    this.setState({ loading: false });
  }
}

export default AuthenticationMobile;
